exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-advanced-search-js": () => import("./../../../src/pages/advanced-search.js" /* webpackChunkName: "component---src-pages-advanced-search-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-video-page-js": () => import("./../../../src/templates/videoPage.js" /* webpackChunkName: "component---src-templates-video-page-js" */)
}

